import { Route, Routes } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import PageNotFound from '../pages/ErrorPage/PageNotFound';
import DashboardLayout from '../layouts/DashboardLayout';
//@ts-ignore
import { TicketRouterService } from '@careinfo/merchant-ticket-service';
//@ts-ignore
import { LogisticOverViewRouterService } from '@careinfo/merchant-logistic-overview-service';

//@ts-ignore
import { CourierInvoiceRouterService } from '@careinfo/merchant-courier-invoice-service';

//@ts-ignore
import { APIIntegrationRouterService } from '@careinfo/api-integration-service';
//@ts-ignore
import { RoleRouterService } from '@careinfo/role';
//@ts-ignore
import { MerchantDeliveryChargeRouterService } from '@careinfo/merchant-delivery-charge-service';
//@ts-ignore
import { MerchantPickupRequestRouterService } from '@careinfo/merchant-pickup-request-service';
//@ts-ignore
import { LogisticOrderRouterService } from '@careinfo/merchant-logistic-order-service';
//@ts-ignore
import { MerchantUserRouterService } from '@careinfo/user';
//@ts-ignore
import { MerchantDestinationRouterService } from '@careinfo/merchant-branch-service';
//@ts-ignore
import {
  AccessControl,
  PermissionRequired,
  //@ts-ignore
} from '@careinfo/merchant-permission-service';
//@ts-ignore
import { WelcomeRouterService } from '@careinfo/welcome-page-service';
import { getKey } from '../helpers/sessionKey';

const Router = () => {
  const shouldShowWelcome = getKey('shouldShowWelcome');
  return (
    <Routes>
      <Route
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        <Route
          path={'/'}
          element={
            shouldShowWelcome === 'true' || shouldShowWelcome === null ? (
              <WelcomeRouterService />
            ) : (
              <LogisticOverViewRouterService />
            )
          }
        />
        <Route path={'/overview'} element={<LogisticOverViewRouterService />} />
        <Route path={'/ticket'} element={<TicketRouterService />} />
        <Route path={'/order'} element={<LogisticOrderRouterService />} />
        <Route path={'/invoice'} element={<CourierInvoiceRouterService />} />
        <Route
          path={'/api-integration'}
          element={<APIIntegrationRouterService />}
        />
        <Route
          path={'/delivery-charge'}
          element={<MerchantDeliveryChargeRouterService />}
        />
        <Route
          path={'/branch'}
          element={<MerchantDestinationRouterService />}
        />
        <Route
          path={'/pickup-request'}
          element={<MerchantPickupRequestRouterService />}
        />
        <Route
          path={'/users'}
          element={
            <AccessControl
              children={<MerchantUserRouterService />}
              allowedPermissions={['can_view_user']}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={'/roles'}
          element={
            <AccessControl
              children={<RoleRouterService />}
              allowedPermissions={['can_view_group']}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route path='/*' element={<PageNotFound />} />
      </Route>
    </Routes>
  );
};

export default Router;
